(function () {
  'use strict';

  angular.module('wsLrs.directives').directive("wsReplaceTag", function () {
    return function (scope, element, attrs) {
      var newTag = attrs.wsReplaceTag;
      var nodeAttributes = {};
      $.each(element[0].attributes, function (idx, attr) {
        nodeAttributes[attr.nodeName] = attr.nodeValue;
      });
      element.replaceWith(function () {
        return $("<" + newTag + "/>", nodeAttributes).append(element.contents());
      });
    };
  });
})();
